// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-table  { min-width: 2130px; table-layout: fixed; }
.cable-table { min-width: 1110px; }

/* Hide number input spinners */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
input[type="number"] { -moz-appearance: textfield; }

.data-row-click { cursor: pointer; outline: none; }
.data-row-click:hover td { background: var(--bg-hover); }
.data-row-click:focus td { background: var(--bg-active); }

.row-editing td {
  background: var(--bg-tertiary) !important;
  padding: 3px 4px;
}
.row-editing td input:not([type="checkbox"]),
.row-editing td select {
  width: 100%;
  font-size: 12px;
  padding: 2px 5px;
}

.cell-input-wide { width: 100%; }
.cell-input-mono { font-family: monospace !important; }
.cell-select     { width: 100%; }
.num-input  { width: 100%; text-align: right; }
.pct-input  { width: 100%; text-align: right; }

.cell-ro { color: var(--text-muted); font-size: 11px; font-style: italic; }

.cell-actions { white-space: nowrap; }
.cell-actions .btn-icon { display: inline-flex; }
.btn-icon-danger:hover { color: var(--red) !important; background: var(--red-dim) !important; }

.cell-from-to {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-note {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Persistent new row at the bottom */
.row-new td { background: rgba(14,99,156,0.07) !important; }
.row-new:hover td { background: rgba(14,99,156,0.12) !important; }

.row-error {
  background: var(--red-dim);
  color: var(--red);
  padding: 4px 16px;
  font-size: 12px;
  flex-shrink: 0;
}

.row-summary td {
  background: var(--bg-tertiary) !important;
  border-top: 2px solid var(--border);
  padding: 4px 10px;
}
.summary-label { font-size: 11px; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.05em; }
.summary-val   { font-weight: 600; font-size: 12px; color: var(--text-secondary); }
`, "",{"version":3,"sources":["webpack://./src/components/items/Items.css"],"names":[],"mappings":"AAAA,eAAe,iBAAiB,EAAE,mBAAmB,EAAE;AACvD,eAAe,iBAAiB,EAAE;;AAElC,+BAA+B;AAC/B;kDACkD,wBAAwB,EAAE,SAAS,EAAE;AACvF,uBAAuB,0BAA0B,EAAE;;AAEnD,kBAAkB,eAAe,EAAE,aAAa,EAAE;AAClD,2BAA2B,2BAA2B,EAAE;AACxD,2BAA2B,4BAA4B,EAAE;;AAEzD;EACE,yCAAyC;EACzC,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB,WAAW,EAAE;AAChC,mBAAmB,iCAAiC,EAAE;AACtD,mBAAmB,WAAW,EAAE;AAChC,cAAc,WAAW,EAAE,iBAAiB,EAAE;AAC9C,cAAc,WAAW,EAAE,iBAAiB,EAAE;;AAE9C,WAAW,wBAAwB,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAE1E,gBAAgB,mBAAmB,EAAE;AACrC,0BAA0B,oBAAoB,EAAE;AAChD,yBAAyB,4BAA4B,EAAE,qCAAqC,EAAE;;AAE9F;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC,cAAc,2CAA2C,EAAE;AAC3D,oBAAoB,2CAA2C,EAAE;;AAEjE;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,iBAAiB;AACnB;AACA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACjI,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,4BAA4B,EAAE","sourcesContent":[".item-table  { min-width: 2130px; table-layout: fixed; }\n.cable-table { min-width: 1110px; }\n\n/* Hide number input spinners */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }\ninput[type=\"number\"] { -moz-appearance: textfield; }\n\n.data-row-click { cursor: pointer; outline: none; }\n.data-row-click:hover td { background: var(--bg-hover); }\n.data-row-click:focus td { background: var(--bg-active); }\n\n.row-editing td {\n  background: var(--bg-tertiary) !important;\n  padding: 3px 4px;\n}\n.row-editing td input:not([type=\"checkbox\"]),\n.row-editing td select {\n  width: 100%;\n  font-size: 12px;\n  padding: 2px 5px;\n}\n\n.cell-input-wide { width: 100%; }\n.cell-input-mono { font-family: monospace !important; }\n.cell-select     { width: 100%; }\n.num-input  { width: 100%; text-align: right; }\n.pct-input  { width: 100%; text-align: right; }\n\n.cell-ro { color: var(--text-muted); font-size: 11px; font-style: italic; }\n\n.cell-actions { white-space: nowrap; }\n.cell-actions .btn-icon { display: inline-flex; }\n.btn-icon-danger:hover { color: var(--red) !important; background: var(--red-dim) !important; }\n\n.cell-from-to {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cell-note {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Persistent new row at the bottom */\n.row-new td { background: rgba(14,99,156,0.07) !important; }\n.row-new:hover td { background: rgba(14,99,156,0.12) !important; }\n\n.row-error {\n  background: var(--red-dim);\n  color: var(--red);\n  padding: 4px 16px;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.row-summary td {\n  background: var(--bg-tertiary) !important;\n  border-top: 2px solid var(--border);\n  padding: 4px 10px;\n}\n.summary-label { font-size: 11px; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.05em; }\n.summary-val   { font-weight: 600; font-size: 12px; color: var(--text-secondary); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
